import { inject, Injectable } from '@angular/core';
import { SessionStorageService } from '../../../../core/services/session-storage/session-storage.service';
import { environment } from '../../../../../environments/environment';
import axios, { AxiosError, AxiosRequestConfig } from 'axios';

@Injectable({
  providedIn: 'root'
})
export class AgentOnboardingService {

  private sessionStorageService = inject(SessionStorageService);

  constructor() { }

  async getAgentOnboardList() {

    const API_URL: string = environment.baseUrl + environment.apis.getAgentOnboardList;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: {
        "piasRepCode": this.sessionStorageService.getCurrentRepCode().toString()
      }
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }

  async statusreturn(data: any) {

    const API_URL: string = environment.baseUrl + environment.apis.returnstatusbyrole;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: {
        id: data.id,
        status: data.status,
        return_comments:data.return_comments
      }
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });

  }

  /**
   * Onboarding timeline for one application — every status it has moved
   * through, with the timestamp and the user responsible.
   *
   * ⚠️ Backed by `environment.apis.getOnboardingAuditLog`, which is NOT yet
   * implemented on the Go API. See `onboarding-audit-log.interface.ts` for the
   * assumed response shape.
   */
  async getOnboardingAuditLog(id: number) {

    const API_URL: string = environment.baseUrl + environment.apis.getOnboardingAuditLog;

    const REQUEST_CONFIG: AxiosRequestConfig = {
      method: 'POST',
      maxBodyLength: Infinity,
      url: API_URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': this.sessionStorageService.getCurrentUserAuthToken()
      },
      data: {
        "unique_key": id
      }
    };

    return await axios.request(REQUEST_CONFIG)
      .then((httpResponse) => {
        return JSON.stringify(httpResponse);
      })
      .catch((error) => {
        throw new AxiosError(error.response.data, error.status);
      });
  }


}
